import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from '../../../internal/cx.js';
/** Hides content visually while keeping it available to assistive technology. */
export function VisuallyHidden({ className, ...rest }) {
    return _jsx("span", { ...rest, className: cx('mn-visually-hidden', className) });
}
//# sourceMappingURL=visually-hidden.js.map